<template>
  <div class="veiculos-page">
    <div class="breadcrumb-bar">
      <span class="breadcrumb">Veículos / Mapa de Pneus</span>
      <button class="back-btn" @click="voltar">
        <v-icon left size="20" color="white">mdi-undo</v-icon>
        Voltar
      </button>
    </div>
    <div class="conteudo">
      
      <!-- Conteúdo do mapa de pneus aqui -->
    </div>
  </div>
</template>

<script>
export default {
  name: "MapaPneusVeiculo",
  methods: {
    voltar() {
      this.$router.push("/veiculos");
    },
  },
};
</script>

<style scoped>
@import "../../assets/inter-font.css";

.veiculos-page {
  background: #fff;
  font-family: "Inter", sans-serif;
  color: #1f2a44;
  padding: 24px;
}
.breadcrumb-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 12px;
  margin-bottom: 24px;
}
.breadcrumb {
  font-size: 1.1em;
  color: #10b981;
  font-weight: 800;
}
.back-btn {
  background: #10b981;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 0.95em;
  font-weight: 600;
  transition: background 0.2s;
}
.back-btn:hover {
  background: #0e9e6c;
}
.conteudo {
  margin-top: 24px;
}
</style>
